<template>
  <div class="addEdit-block">
    <el-form
      class="detail-form-content"
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="80px"
	  :style="{backgroundColor:addEditForm.addEditBoxColor}"
    >
      <el-row >
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('fitnessProject.projectName')" prop="xiangmumingcheng">
          <el-input v-model="ruleForm.xiangmumingcheng" 
              :placeholder="$t('fitnessProject.projectName')" clearable  :readonly="ro.xiangmumingcheng"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('fitnessProject.projectName')" prop="xiangmumingcheng">
              <el-input v-model="ruleForm.xiangmumingcheng" 
                :placeholder="$t('fitnessProject.projectName')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      
      <el-col :span="12">
        <el-form-item class="select" v-if="type!='info'"  :label="$t('fitnessProject.projectType')" prop="xiangmuleixing">
          <el-select :disabled="ro.xiangmuleixing" v-model="ruleForm.xiangmuleixing" :placeholder="$t('fitnessProject.selectProjectType')">
            <el-option
                v-for="(item,index) in xiangmuleixingOptions"
                v-bind:key="index"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('fitnessProject.projectType')" prop="xiangmuleixing">
	      <el-input v-model="ruleForm.xiangmuleixing"
                :placeholder="$t('fitnessProject.projectType')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'" :label="$t('fitnessProject.durationMinutes')" prop="durationMinutes">
          <el-input v-model="ruleForm.durationMinutes" :placeholder="$t('fitnessProject.inputDurationMinutes')" clearable :readonly="ro.durationMinutes"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('fitnessProject.durationMinutes')" prop="durationMinutes">
            <el-input v-model="ruleForm.durationMinutes" :placeholder="$t('fitnessProject.durationMinutes')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      
      <!-- 教练选择 - 仅在添加/编辑模式下显示 -->
      <el-col :span="24" v-if="type!='info'">
        <el-form-item :label="$t('fitnessProject.teachingCoaches')" prop="selectedCoaches">
          <el-transfer
            v-model="selectedCoaches"
            :data="allCoaches"
            :titles="[$t('fitnessProject.allCoaches'), $t('fitnessProject.selectedCoaches')]"
            :button-texts="[$t('fitnessProject.remove'), $t('fitnessProject.add')]"
            :render-content="renderCoachContent"
            :props="{
              key: 'jiaolianbianhao',
              label: 'jiaolianxingming'
            }"
            filterable
            :filter-placeholder="$t('fitnessProject.searchCoaches')">
          </el-transfer>
        </el-form-item>
      </el-col>


      <el-col :span="24">  
        <el-form-item class="upload" v-if="type!='info'&& !ro.jianshenshipin" :label="$t('fitnessProject.fitnessVideo')" prop="jianshenshipin">
          <file-upload
          :tip="$t('fitnessProject.clickUploadVideo')"
          action="file/upload"
          :limit="1"
          :multiple="true"
          :fileUrls="ruleForm.jianshenshipin?ruleForm.jianshenshipin:''"
          @change="jianshenshipinUploadChange"
          ></file-upload>
        </el-form-item> 
        <div v-else>
          <el-form-item v-if="ruleForm.jianshenshipin" :label="$t('fitnessProject.fitnessVideo')" prop="jianshenshipin">
            <el-button type="text" size="small" @click="download($base.imgurl+ruleForm.jianshenshipin)">{{ $t('fitnessProject.preview') }}</el-button>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="24">  
        <el-form-item class="upload" v-if="type!='info' && !ro.xiangmutupian" :label="$t('fitnessProject.projectImage')" prop="xiangmutupian">
          <file-upload
          :tip="$t('fitnessProject.clickUploadImage')"
          action="file/upload"
          :limit="3"
          :multiple="true"
          :fileUrls="ruleForm.xiangmutupian?ruleForm.xiangmutupian:''"
          @change="xiangmutupianUploadChange"
          ></file-upload>
        </el-form-item>
        <div v-else>
          <el-form-item v-if="ruleForm.xiangmutupian" :label="$t('fitnessProject.projectImage')" prop="xiangmutupian">
            <img style="margin-right:20px;" v-bind:key="index" v-for="(item,index) in ruleForm.xiangmutupian.split(',')" :src="$base.imgurl+item" width="100" height="100">
          </el-form-item>
        </div>
      </el-col>
      </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item class="textarea" v-if="type!='info'" :label="$t('fitnessProject.effect')" prop="jianshenxiaoguo">
                <el-input
                  style="min-width: 200px; max-width: 600px;"
                  type="textarea"
                  :rows="8"
                  placeholder="健身效果"
                  v-model="ruleForm.jianshenxiaoguo" >
                </el-input>
              </el-form-item>
              <div v-else>
                <el-form-item v-if="ruleForm.jianshenxiaoguo" :label="$t('fitnessProject.effect')" prop="jianshenxiaoguo">
                    <span>{{ruleForm.jianshenxiaoguo}}</span>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item v-if="type!='info'"  :label="$t('fitnessProject.detail')" prop="xiangmujieshao">
                <editor 
                    style="min-width: 200px; max-width: 600px;"
                    v-model="ruleForm.xiangmujieshao" 
                    class="editor" 
                    action="file/upload">
                </editor>
              </el-form-item>
              <div v-else>
                <el-form-item v-if="ruleForm.xiangmujieshao" :label="$t('fitnessProject.detail')" prop="xiangmujieshao">
                    <span v-html="ruleForm.xiangmujieshao"></span>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
      <el-form-item class="btn">
        <el-button  v-if="type!='info'" type="primary" class="btn-success" @click="onSubmit">{{ $t('common.submit') }}</el-button>
        <el-button v-if="type!='info'" class="btn-close" @click="back()">{{ $t('common.cancel') }}</el-button>
        <el-button v-if="type=='info'" class="btn-close" @click="back()">{{ $t('common.back') }}</el-button>
      </el-form-item>
    </el-form>
    
    <!-- 教授教练 - 仅在详情模式下显示 -->
    <div v-if="type === 'info'" class="coach-info">
      <el-divider content-position="left">
        <span style="font-weight: bold; font-size: 16px;">{{ $t('missingTranslations.teachingCoaches') }}</span>
      </el-divider>
      
      <el-table 
        :data="coachList" 
        v-loading="coachLoading"
        border
        style="width: 100%; margin-top: 20px;">
        <el-table-column type="index" :label="$t('common.index')" width="60"></el-table-column>
        <el-table-column prop="jiaolianbianhao" :label="$t('coach.id')" width="120"></el-table-column>
        <el-table-column prop="jiaolianxingming" :label="$t('coach.name')" width="120"></el-table-column>
        <el-table-column prop="xingbie" :label="$t('coach.gender')" width="80"></el-table-column>
        <el-table-column prop="nianling" :label="$t('coach.age')" width="80"></el-table-column>
        <el-table-column prop="jiaoliandengji" :label="$t('coach.level')" width="120"></el-table-column>
        <el-table-column prop="lianxidianhua" :label="$t('coach.phone')" width="140"></el-table-column>
        <el-table-column prop="touxiang" :label="$t('coach.image')" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.touxiang" :src="$base.imgurl + scope.row.touxiang" style="width: 50px; height: 50px; object-fit: cover;">
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="addtime" :label="$t('common.createTime')" width="160">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.addtime) }}
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 教练统计信息 -->
      <div class="coach-summary" style="margin-top: 20px; padding: 15px; background: #f5f7fa; border-radius: 8px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="summary-item">
              <div class="summary-label">{{ $t('missingTranslations.coachCount') }}</div>
              <div class="summary-value">{{ coachStats.totalCount }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="summary-item">
              <div class="summary-label">{{ $t('missingTranslations.avgAge') }}</div>
              <div class="summary-value" style="color: #409EFF;">{{ coachStats.avgAge }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="summary-item">
              <div class="summary-label">{{ $t('missingTranslations.levelDistribution') }}</div>
              <div class="summary-value" style="color: #67C23A;">{{ coachStats.levelDistribution }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
  data() {
    let self = this
    var validateIdCard = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!checkIdCard(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    var validateUrl = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isURL(value)) {
        callback(new Error("请输入正确的URL地址"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isMobile(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isPhone(value)) {
        callback(new Error("请输入正确的电话号码"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isEmail(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    var validateNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isNumber(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    var validateIntNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isIntNumer(value)) {
        callback(new Error("请输入整数"));
      } else {
        callback();
      }
    };
    return {
	  addEditForm: {"btnSaveFontColor":"#fff","selectFontSize":"14px","btnCancelBorderColor":"#DCDFE6","inputBorderRadius":"4px","inputFontSize":"14px","textareaBgColor":"#fff","btnSaveFontSize":"14px","textareaBorderRadius":"4px","uploadBgColor":"#fff","textareaBorderStyle":"solid","btnCancelWidth":"88px","textareaHeight":"120px","dateBgColor":"#fff","btnSaveBorderRadius":"4px","uploadLableFontSize":"14px","textareaBorderWidth":"3px","inputLableColor":"rgba(0, 0, 0, 1)","addEditBoxColor":"rgba(255, 255, 255, 0)","dateIconFontSize":"14px","btnSaveBgColor":"rgba(64, 158, 255, 1)","uploadIconFontColor":"rgba(119, 197, 227, 1)","textareaBorderColor":"rgba(119, 197, 227, 1)","btnCancelBgColor":"rgba(64, 158, 255, 1)","selectLableColor":"rgba(0, 0, 0, 1)","btnSaveBorderStyle":"solid","dateBorderWidth":"3px","dateLableFontSize":"14px","dateBorderRadius":"4px","btnCancelBorderStyle":"solid","selectLableFontSize":"14px","selectBorderStyle":"solid","selectIconFontColor":"rgba(0, 0, 0, 1)","btnCancelHeight":"44px","inputHeight":"45px","btnCancelFontColor":"rgba(255, 255, 255, 1)","dateBorderColor":"rgba(119, 197, 227, 1)","dateIconFontColor":"rgba(0, 0, 0, 1)","uploadBorderStyle":"solid","dateBorderStyle":"solid","dateLableColor":"rgba(0, 4, 11, 1)","dateFontSize":"14px","inputBorderWidth":"3px","uploadIconFontSize":"28px","selectHeight":"40px","inputFontColor":"rgba(0, 0, 0, 1)","uploadHeight":"148px","textareaLableColor":"rgba(0, 0, 0, 1)","textareaLableFontSize":"14px","btnCancelFontSize":"14px","inputBorderStyle":"solid","btnCancelBorderRadius":"4px","inputBgColor":"#fff","inputLableFontSize":"14px","uploadLableColor":"rgba(0, 0, 0, 1)","uploadBorderRadius":"4px","btnSaveHeight":"44px","selectBgColor":"#fff","btnSaveWidth":"88px","selectIconFontSize":"14px","dateHeight":"45px","selectBorderColor":"rgba(119, 197, 227, 1)","inputBorderColor":"rgba(119, 197, 227, 1)","uploadBorderColor":"rgba(119, 197, 227, 1)","textareaFontColor":"rgba(0, 0, 0, 1)","selectBorderWidth":"3px","dateFontColor":"rgba(0, 1, 2, 1)","btnCancelBorderWidth":"0","uploadBorderWidth":"3px","textareaFontSize":"15px","selectBorderRadius":"4px","selectFontColor":"rgba(0, 0, 0, 1)","btnSaveBorderColor":"rgba(64, 158, 255, 1)","btnSaveBorderWidth":"0"},
      id: '',
      type: '',
      ro:{
	xiangmumingcheng : false,
	xiangmuleixing : false,
	jianshenxiaoguo : false,
	jianshenshipin : false,
	xiangmujieshao : false,
	xiangmutupian : false,
	clicktime : false,
	clicknum : false,
  jiaolianIds: false,
  coachIds: false,
      },
      ruleForm: {
        coachIds: [],
        jiaolianIds: [],  // 存储选中的教练 ID
        xiangmumingcheng: '',
        xiangmuleixing: '',
        jianshenxiaoguo: '',
        jianshenshipin: '',
        xiangmujieshao: '',
        xiangmutupian: '',
        clicktime: '',
        durationMinutes: null, // 新增的时长字段
      },
      allCoaches: [],  // 所有教练列表
      selectedCoaches: [], // 当前项目的教练
      coachList: [], // 详情模式下显示的教练列表
      coachLoading: false,
      coachStats: {
        totalCount: 0,
        avgAge: 0,
        levelDistribution: ''
      },
      xiangmuleixingOptions: [],
      rules: {
        coachIds: [],
          xiangmumingcheng: [
          ],
          xiangmuleixing: [
          ],
          jianshenxiaoguo: [
          ],
          jianshenshipin: [
          ],
          xiangmujieshao: [
          ],
          xiangmutupian: [
          ],
          clicktime: [
          ],
          clicknum: [
                { validator: validateIntNumber, trigger: 'blur' },
          ],
      }
    };
  },
  props: ["parent"],
  computed: {



  },
  created() {
	this.addEditStyleChange()
	this.addEditUploadStyleChange()
      // this.fetchCoaches() // 获取教练数据
      console.log("ruleForm", this.ruleForm);
    
   this.fetchAllCoaches();
  // if (this.ruleForm.xiangmumingcheng) {
  //   this.fetchCoachesForProject();
  // }
  // this.fetchAllCoaches().then(() => {
  //   if (this.ruleForm.xiangmumingcheng) {
  //     this.fetchCoachesForProject();
  //   }
  // });
  // if (this.id) {
  //   console.log("this.id",this.id);
  //   this.fetchProjectDetails(this.id).then(() => {
  //     this.fetchAllCoaches().then(() => {
  //       if (this.ruleForm.xiangmumingcheng) {
  //         this.fetchCoachesForProject();
  //       }
  //     });
  //   });
  // } else {
  //   this.fetchAllCoaches();
  // }
  if (this.id) {
    console.log("this.id",this.id);
    this.info(this.id); // 获取项目详情
  }
  },
  watch: {
  'ruleForm.xiangmumingcheng'(newVal) {
    if (newVal) {
      console.log("newVal",newVal);
      this.fetchCoachesForProject();
      this.$nextTick(() => {
  console.log("教授教练 IDs:", this.ruleForm.jiaolianIds);
});
    }
  }
},
  methods: {
//     async fetchProjectDetails(id) {
//   try {
//     const response = await this.$http.get(`/jianshenxiangmu/info/${id}`);
//     this.ruleForm = response.data.data;
//   } catch (error) {
//     this.$message.error('获取项目详情失败');
//   }
// },

    async fetchAllCoaches() {
  try {
    const response = await this.$http.get('/jiaolian/list');
    console.log("fetch jiaolian", response);  // 确认数据结构
    this.allCoaches = response.data.data.list; // 确保正确赋值
    console.log("this.ruleForm after", this.ruleForm);
    
  } catch (error) {
    this.$message.error('获取教练列表失败');
  }
},

  async fetchCoachesForProject() {
    try {
      const response = await this.$http.get(`/jianshenxiangmu/${this.ruleForm.xiangmumingcheng}/coaches`);
      console.log("fetch selected jiaolian",response);
      console.log("this.ruleForm",this.ruleForm);

      if (response.data && response.data.code === 0) {
        const coachIds = response.data.data.map(coach => coach.jiaolianbianhao);
        this.ruleForm.jiaolianIds = coachIds;
        this.selectedCoaches = coachIds;
      }

    } catch (error) {
      console.error('获取项目的教练失败:', error);
      this.$message.error('获取项目的教练失败');
    }
  },
  async updateCoaches() {
    try {
      // 使用 selectedCoaches 而不是 jiaolianIds
      const response = await this.$http.post(`/jianshenxiangmu/${this.ruleForm.xiangmumingcheng}/updateCoaches`, this.selectedCoaches);
      if (response.data && response.data.code === 0) {
        console.log('更新教练成功');
      } else {
        console.error('更新教练失败:', response.data.msg);
      }
    } catch (error) {
      console.error('更新教练失败:', error);
    }
  },
  //   async updateCoaches() {
  //   try {
  //     await this.$http.post(`/jianshenxiangmu/${this.ruleForm.id}/updateCoaches`, this.ruleForm.jiaolianIds);
  //     this.$message.success('更新教练成功');
  //   } catch (error) {
  //     this.$message.error('更新教练失败');
  //   }
  // },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 初始化
    init(id,type) {
      if (id) {
        this.id = id;
        this.type = type;
      }
      if(this.type=='info'||this.type=='else'){
        this.info(id);
      }else if(this.type=='logistics'){
        this.logistics=false;
        this.info(id);
      }else if(this.type=='cross'){
        var obj = this.$storage.getObj('crossObj');
        console.log("obj",obj);
        for (var o in obj){
          if(o=='xiangmumingcheng'){
            this.ruleForm.xiangmumingcheng = obj[o];
	    this.ro.xiangmumingcheng = true;
            continue;
          }
          if(o=='xiangmuleixing'){
            this.ruleForm.xiangmuleixing = obj[o];
	    this.ro.xiangmuleixing = true;
            continue;
          }
          if(o=='jianshenxiaoguo'){
            this.ruleForm.jianshenxiaoguo = obj[o];
	    this.ro.jianshenxiaoguo = true;
            continue;
          }
          if(o=='jianshenshipin'){
            this.ruleForm.jianshenshipin = obj[o];
	    this.ro.jianshenshipin = true;
            continue;
          }
          if(o=='xiangmujieshao'){
            this.ruleForm.xiangmujieshao = obj[o];
	    this.ro.xiangmujieshao = true;
            continue;
          }
          if(o=='xiangmutupian'){
            this.ruleForm.xiangmutupian = obj[o];
	    this.ro.xiangmutupian = true;
            continue;
          }
          if(o=='clicktime'){
            this.ruleForm.clicktime = obj[o];
	    this.ro.clicktime = true;
            continue;
          }
          if(o=='clicknum'){
            this.ruleForm.clicknum = obj[o];
	    this.ro.clicknum = true;
            continue;
          }
        }
      }
      // 获取用户信息
      this.$http({
        url: `${this.$storage.get('sessionTable')}/session`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var json = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
            this.$http({
              url: `option/xiangmufenlei/leixing`,
              method: "get"
            }).then(({ data }) => {
              if (data && data.code === 0) {
                this.xiangmuleixingOptions = data.data;
              } else {
                this.$message.error(data.msg);
              }
            });
         
    },
    // 多级联动参数
    info(id) {
      this.$http({
        url: `jianshenxiangmu/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
	//解决前台上传图片后台不显示的问题
	let reg=new RegExp('../../../upload','g')//g代表全部
	this.ruleForm.xiangmujieshao = (this.ruleForm.xiangmujieshao || '').replace(reg, this.$base.imgurl + 'upload');
	
	// 加载该项目关联的教练
	this.fetchCoachesForProject();
	
	// 如果是详情模式，获取教练详细信息
	if (this.type === 'info') {
	  this.getCoachDetails();
	}
        } else {
          this.$message.error(data.msg);
        }
      });
    },

// async fetchCoaches() {
//         try {
//             const response = await this.$http.get('/jiaolian/list');
//             console.log("jiaolian list", response);
//             this.coaches = response.data.data.list;
//         } catch (error) {
//             this.$message.error('获取教练列表失败');
//             console.error(error);
//         }
//     },

    // 提交
    async onSubmit() {
      // 处理图片路径
      if(this.ruleForm.jianshenshipin!=null) {
        this.ruleForm.jianshenshipin = this.ruleForm.jianshenshipin.replace(new RegExp(this.$base.url,"g"),"");
      }

      if(this.ruleForm.xiangmutupian!=null) {
        this.ruleForm.xiangmutupian = this.ruleForm.xiangmutupian.replace(new RegExp(this.$base.url,"g"),"");
      }

      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$http({
            url: `jianshenxiangmu/${!this.ruleForm.id ? "save" : "update"}`,
            method: "post",
            data: this.ruleForm
          }).then(async ({ data }) => {
            if (data && data.code === 0) {
              // 项目保存成功后，更新教练关联
              if (this.selectedCoaches.length > 0) {
                await this.updateCoaches();
              }
              
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.parent.showFlag = true;
                  this.parent.addOrUpdateFlag = false;
                  this.parent.search();
                  this.parent.contentStyleChange();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.jianshenxiangmuCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    jianshenshipinUploadChange(fileUrls) {
	this.ruleForm.jianshenshipin = fileUrls;
	this.addEditUploadStyleChange()
    },
    xiangmutupianUploadChange(fileUrls) {
	this.ruleForm.xiangmutupian = fileUrls;
	this.addEditUploadStyleChange()
    },
	addEditStyleChange() {
	  this.$nextTick(()=>{
	    // input
	    document.querySelectorAll('.addEdit-block .input .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.inputHeight
	      el.style.color = this.addEditForm.inputFontColor
	      el.style.fontSize = this.addEditForm.inputFontSize
	      el.style.borderWidth = this.addEditForm.inputBorderWidth
	      el.style.borderStyle = this.addEditForm.inputBorderStyle
	      el.style.borderColor = this.addEditForm.inputBorderColor
	      el.style.borderRadius = this.addEditForm.inputBorderRadius
	      el.style.backgroundColor = this.addEditForm.inputBgColor
	    })
	    document.querySelectorAll('.addEdit-block .input .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.inputHeight
	      el.style.color = this.addEditForm.inputLableColor
	      el.style.fontSize = this.addEditForm.inputLableFontSize
	    })
	    // select
	    document.querySelectorAll('.addEdit-block .select .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.selectHeight
	      el.style.color = this.addEditForm.selectFontColor
	      el.style.fontSize = this.addEditForm.selectFontSize
	      el.style.borderWidth = this.addEditForm.selectBorderWidth
	      el.style.borderStyle = this.addEditForm.selectBorderStyle
	      el.style.borderColor = this.addEditForm.selectBorderColor
	      el.style.borderRadius = this.addEditForm.selectBorderRadius
	      el.style.backgroundColor = this.addEditForm.selectBgColor
	    })
	    document.querySelectorAll('.addEdit-block .select .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.selectHeight
	      el.style.color = this.addEditForm.selectLableColor
	      el.style.fontSize = this.addEditForm.selectLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .select .el-select__caret').forEach(el=>{
	      el.style.color = this.addEditForm.selectIconFontColor
	      el.style.fontSize = this.addEditForm.selectIconFontSize
	    })
	    // date
	    document.querySelectorAll('.addEdit-block .date .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.dateHeight
	      el.style.color = this.addEditForm.dateFontColor
	      el.style.fontSize = this.addEditForm.dateFontSize
	      el.style.borderWidth = this.addEditForm.dateBorderWidth
	      el.style.borderStyle = this.addEditForm.dateBorderStyle
	      el.style.borderColor = this.addEditForm.dateBorderColor
	      el.style.borderRadius = this.addEditForm.dateBorderRadius
	      el.style.backgroundColor = this.addEditForm.dateBgColor
	    })
	    document.querySelectorAll('.addEdit-block .date .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.dateHeight
	      el.style.color = this.addEditForm.dateLableColor
	      el.style.fontSize = this.addEditForm.dateLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .date .el-input__icon').forEach(el=>{
	      el.style.color = this.addEditForm.dateIconFontColor
	      el.style.fontSize = this.addEditForm.dateIconFontSize
	      el.style.lineHeight = this.addEditForm.dateHeight
	    })
	    // upload
	    let iconLineHeight = parseInt(this.addEditForm.uploadHeight) - parseInt(this.addEditForm.uploadBorderWidth) * 2 + 'px'
	    document.querySelectorAll('.addEdit-block .upload .el-upload--picture-card').forEach(el=>{
	      el.style.width = this.addEditForm.uploadHeight
	      el.style.height = this.addEditForm.uploadHeight
	      el.style.borderWidth = this.addEditForm.uploadBorderWidth
	      el.style.borderStyle = this.addEditForm.uploadBorderStyle
	      el.style.borderColor = this.addEditForm.uploadBorderColor
	      el.style.borderRadius = this.addEditForm.uploadBorderRadius
	      el.style.backgroundColor = this.addEditForm.uploadBgColor
	    })
	    document.querySelectorAll('.addEdit-block .upload .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.uploadHeight
	      el.style.color = this.addEditForm.uploadLableColor
	      el.style.fontSize = this.addEditForm.uploadLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .upload .el-icon-plus').forEach(el=>{
	      el.style.color = this.addEditForm.uploadIconFontColor
	      el.style.fontSize = this.addEditForm.uploadIconFontSize
	      el.style.lineHeight = iconLineHeight
	      el.style.display = 'block'
	    })
	    // 多文本输入框
	    document.querySelectorAll('.addEdit-block .textarea .el-textarea__inner').forEach(el=>{
	      el.style.height = this.addEditForm.textareaHeight
	      el.style.color = this.addEditForm.textareaFontColor
	      el.style.fontSize = this.addEditForm.textareaFontSize
	      el.style.borderWidth = this.addEditForm.textareaBorderWidth
	      el.style.borderStyle = this.addEditForm.textareaBorderStyle
	      el.style.borderColor = this.addEditForm.textareaBorderColor
	      el.style.borderRadius = this.addEditForm.textareaBorderRadius
	      el.style.backgroundColor = this.addEditForm.textareaBgColor
	    })
	    document.querySelectorAll('.addEdit-block .textarea .el-form-item__label').forEach(el=>{
	      // el.style.lineHeight = this.addEditForm.textareaHeight
	      el.style.color = this.addEditForm.textareaLableColor
	      el.style.fontSize = this.addEditForm.textareaLableFontSize
	    })
	    // 保存
	    document.querySelectorAll('.addEdit-block .btn .btn-success').forEach(el=>{
	      el.style.width = this.addEditForm.btnSaveWidth
	      el.style.height = this.addEditForm.btnSaveHeight
	      el.style.color = this.addEditForm.btnSaveFontColor
	      el.style.fontSize = this.addEditForm.btnSaveFontSize
	      el.style.borderWidth = this.addEditForm.btnSaveBorderWidth
	      el.style.borderStyle = this.addEditForm.btnSaveBorderStyle
	      el.style.borderColor = this.addEditForm.btnSaveBorderColor
	      el.style.borderRadius = this.addEditForm.btnSaveBorderRadius
	      el.style.backgroundColor = this.addEditForm.btnSaveBgColor
	    })
	    // 返回
	    document.querySelectorAll('.addEdit-block .btn .btn-close').forEach(el=>{
	      el.style.width = this.addEditForm.btnCancelWidth
	      el.style.height = this.addEditForm.btnCancelHeight
	      el.style.color = this.addEditForm.btnCancelFontColor
	      el.style.fontSize = this.addEditForm.btnCancelFontSize
	      el.style.borderWidth = this.addEditForm.btnCancelBorderWidth
	      el.style.borderStyle = this.addEditForm.btnCancelBorderStyle
	      el.style.borderColor = this.addEditForm.btnCancelBorderColor
	      el.style.borderRadius = this.addEditForm.btnCancelBorderRadius
	      el.style.backgroundColor = this.addEditForm.btnCancelBgColor
	    })
	  })
	},
	addEditUploadStyleChange() {
		this.$nextTick(()=>{
		  document.querySelectorAll('.addEdit-block .upload .el-upload-list--picture-card .el-upload-list__item').forEach(el=>{
			el.style.width = this.addEditForm.uploadHeight
			el.style.height = this.addEditForm.uploadHeight
			el.style.borderWidth = this.addEditForm.uploadBorderWidth
			el.style.borderStyle = this.addEditForm.uploadBorderStyle
			el.style.borderColor = this.addEditForm.uploadBorderColor
			el.style.borderRadius = this.addEditForm.uploadBorderRadius
			el.style.backgroundColor = this.addEditForm.uploadBgColor
		  })
	  })
	},

	// 渲染教练内容
	renderCoachContent(h, option) {
	  return h('span', { style: 'margin-left: 10px' }, [
	    h('span', option.jiaolianxingming),
	    h('span', { style: 'margin-left: 10px; color: #909399; font-size: 12px' }, option.jiaoliandengji)
	  ]);
	},

	// 获取教练详细信息（详情模式）
	async getCoachDetails() {
	  this.coachLoading = true;
	  try {
	    // 如果是新建项目且没有项目名称，则使用selectedCoaches来显示教练信息
	    if (!this.ruleForm.xiangmumingcheng && this.selectedCoaches.length > 0) {
	      // 从allCoaches中筛选出选中的教练
	      this.coachList = this.allCoaches.filter(coach => 
	        this.selectedCoaches.includes(coach.jiaolianbianhao)
	      );
	      this.calculateCoachStats();
	    } else if (this.ruleForm.xiangmumingcheng) {
	      // 已保存的项目，通过API获取教练信息
	      const response = await this.$http.get(`/jianshenxiangmu/${this.ruleForm.xiangmumingcheng}/coaches`);
	      if (response.data && response.data.code === 0) {
	        this.coachList = response.data.data || [];
	        this.calculateCoachStats();
	      } else {
	        this.$message.error(response.data.msg || '获取教练信息失败');
	      }
	    } else {
	      this.coachList = [];
	      this.calculateCoachStats();
	    }
	  } catch (error) {
	    console.error('获取教练信息失败:', error);
	    this.$message.error('获取教练信息失败');
	  } finally {
	    this.coachLoading = false;
	  }
	},

	// 计算教练统计信息
	calculateCoachStats() {
	  const stats = {
	    totalCount: this.coachList.length,
	    avgAge: 0,
	    levelDistribution: ''
	  };

	  if (this.coachList.length > 0) {
	    // 计算平均年龄
	    const totalAge = this.coachList.reduce((sum, coach) => {
	      return sum + (parseInt(coach.nianling) || 0);
	    }, 0);
	    stats.avgAge = totalAge > 0 ? (totalAge / this.coachList.length).toFixed(1) : 0;

	    // 统计等级分布
	    const levels = [...new Set(this.coachList.map(c => c.jiaoliandengji).filter(l => l))];
	    stats.levelDistribution = levels.join(', ') || '无';
	  }

	  this.coachStats = stats;
	},

	// 格式化时间
	formatDateTime(timestamp) {
	  if (!timestamp) return '';
	  const date = new Date(timestamp);
	  const year = date.getFullYear();
	  const month = String(date.getMonth() + 1).padStart(2, '0');
	  const day = String(date.getDate()).padStart(2, '0');
	  const hours = String(date.getHours()).padStart(2, '0');
	  const minutes = String(date.getMinutes()).padStart(2, '0');
	  return `${year}-${month}-${day} ${hours}:${minutes}`;
	},
  }
};
</script>
<style lang="scss">
.editor{
  height: 500px;
  
  & /deep/ .ql-container {
	  height: 310px;
  }
}
.amap-wrapper {
  width: 100%;
  height: 500px;
}
.search-box {
  position: absolute;
}
.addEdit-block {
	margin: -10px;
}
.detail-form-content {
	padding: 12px;
	background-color: transparent;
}
.btn .el-button {
  padding: 0;
}

/* 教练信息样式 */
.coach-info {
  margin-top: 30px;
}

.summary-item {
  text-align: center;
  padding: 10px;
}

.summary-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.summary-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.coach-summary {
  margin-top: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.el-divider__text {
  background-color: #fff;
  padding: 0 20px;
}
</style>
